import { DiAngularSimple, DiApple, DiChrome, DiFirefox, DiGit, DiLinux, DiNodejsSmall, DiNpm, DiReact, DiVisualstudio, DiWindows } from 'react-icons/di';
import { useTranslation } from 'react-i18next';

import HistoryCard from '../../components/historyCard/historyCard';
import meImg from '../../imgs/dwain.webp'

import './me.scss'

function Me() {
  const { t } = useTranslation()
  
  return (
    <div className='page-me'>

      <div className='me-content'>
        
        <div className='content-about'>
          <div className='about-header'>
            <div className='header-name'>Dwain Reinert</div>
            <div className='header-title'>Senior Fullstack Developer</div>
            <div>
              <div className='header-img'><img src={meImg} alt=''/></div>
            </div>
          </div>

          <div className='about-use'>
            <div>
              <DiVisualstudio />
            </div>
            <div>
              <DiNpm />
              <DiGit />
            </div>
            <div>
              <DiChrome />
              <DiFirefox />
            </div>
            <div>
              <DiNodejsSmall />
              <DiReact />
              <DiAngularSimple />
            </div>
            <div>
              <DiWindows />
              <DiLinux />
              <DiApple />
            </div>
          </div>
        </div>

        <div className='content-me'>
          
          <div className='me-info'>
            {t('me.infoText1')}
            <br/>
            <br/>
            {t('me.infoText2')}
            <br/>
            <br/>
            {t('me.infoText3')}
            <br/>
            <br/>
            {t('me.infoText4')}
            <br/>
            <br/>
            {t('me.infoText5')}
          </div>

          <div className='me-history'>
            <HistoryCard
              fromTo={'2018 - ' + t('general.now')}
              position={t('me.card.2018.position')}
              url='Soccerwatch.tv / Staige.tv'
              text={t('me.card.2018.text')}
              devTypes={['javascript', 'typescript', 'node', 'react', 'angular', 'html', 'css', 'scss','googlecloud']}
            />

            <HistoryCard
              fromTo='2016 - 2018'
              position={t('me.card.2016.position')}
              url='sandboxer.de'
              text={t('me.card.2016.text')}
              devTypes={[ 'wordpress', 'html', 'scss' ]}
            />

            <HistoryCard
              fromTo='2013 - 2020'
              position={t('me.card.2013.position')}
              url='BlackDesert-Online.de'
              text={t('me.card.2013.text')}
              devTypes={[ 'wordpress', 'html', 'css' ]}
            />

            <HistoryCard
              fromTo='2011 - 2019'
              position={t('me.card.2011.position')}
              url='ArcheAge-Online.de'
              text={t('me.card.2011.text')}
              devTypes={[ 'joomla', 'html', 'css' ]}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Me
